// removed by extract-text-webpack-plugin
module.exports = {"register-step":"register-step","subtitle":"subtitle","error-message":"error-message","general":"general","form-group":"form-group","error":"error","form-actions":"form-actions"};


//////////////////
// WEBPACK FOOTER
// ./src/presentation/scene/conversion-quiz/steps/register/register.style.sass
// module id = QD74
// module chunks = 1